import { useDispatch } from "react-redux";
import { openToast } from "store/slices/toast.slice";

// ------------------ copy function --------------------------
export const useHandleCopy = () => {
  const dispatch = useDispatch();

  const handleCopy = async (data, msg) => {
    try {
      await navigator.clipboard.writeText(data);
      dispatch(
        openToast({
          type: "success",
          message: msg,
        }),
      );
    } catch (err) {
      dispatch(
        openToast({
          type: "error",
          message: "Failed to copy data",
        }),
      );
      console.error("Failed to copy text: ", err);
    }
  };

  return handleCopy;
};

//----------- check correpted file or not --------------
export const isValidFile = async (file) => {
  try {
    // empty file
    if (!file || file.size === 0) {
      return false;
    }

    const buffer = await file.arrayBuffer();

    // file read check
    if (!buffer || buffer.byteLength !== file.size) {
      return false;
    }

    // image actual decode check
    if (file.type.startsWith("image/")) {
      return await new Promise((resolve) => {
        const img = new Image();
        const url = URL.createObjectURL(file);

        img.onload = () => {
          URL.revokeObjectURL(url);
          resolve(true);
        };

        img.onerror = () => {
          URL.revokeObjectURL(url);
          resolve(false);
        };

        img.src = url;
      });
    }

    // video/audio decode check
    if (file.type.startsWith("video/") || file.type.startsWith("audio/")) {
      return await new Promise((resolve) => {
        const media = document.createElement(
          file.type.startsWith("video/") ? "video" : "audio",
        );

        const url = URL.createObjectURL(file);

        media.onloadedmetadata = () => {
          URL.revokeObjectURL(url);
          resolve(true);
        };

        media.onerror = () => {
          URL.revokeObjectURL(url);
          resolve(false);
        };

        media.src = url;
      });
    }

    // pdf / doc / zip / other files
    // minimum binary readable check
    const firstByte = new Uint8Array(buffer.slice(0, 10));

    if (!firstByte.length) {
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
};

// export const extractIdsFromSelection = (selectedItems = []) => {
//   return selectedItems.reduce(
//     (acc, item) => {
//       const separatorIndex = item.indexOf("-");

//       if (separatorIndex === -1) return acc;

//       const type = item.slice(0, separatorIndex);
//       const id = item.slice(separatorIndex + 1);

//       if (type === "folder") acc.selectedFolderIds.push(id);
//       else if (type === "file") acc.selectedFileIds.push(id);

//       return acc;
//     },
//     { selectedFolderIds: [], selectedFileIds: [] },
//   );
// };
